import React, { useState, useRef } from 'react';

import { classNames } from '../../utils/style';
import { Viewer } from '../../components/Viewer';
import { TabIndicator } from '../../components/TabIndicator';
import { TitleAndParagraphTab } from './TitleAndParagraphTab';
import { Picto } from '../../components/Picto';

export interface TitleAndParagraphTabProps {
  title: string;
  selected?: boolean;
  picto?: any;
  titleAndDescriptionElements: {
    title: string;
    description: string;
  }[];
}

export interface TitleAndParagraphTabsProps {
  data: TitleAndParagraphTabProps[];
  className?: string;
}

export const TitleAndParagrapheTabs = ({
  className,
  data,
}: TitleAndParagraphTabsProps) => {
  const [selectedIndex, setSelectedIndex] = useState(0);
  const tabRefs = useRef<any[]>([]);

  return (
    <div className={classNames('TitleAndParagrapheTabs w-full', className)}>
      <TabIndicator selectedIndex={selectedIndex}>
        {data?.map(({ title, picto, ...item }, i) => (
          <TitleAndParagraphTab
            ref={(el) => (tabRefs.current[i] = el)}
            {...item}
            key={i}
            className="max-w-max gap-16"
            selected={selectedIndex === i}
            onClick={() => {
              const Tabsindicator =
                tabRefs?.current?.[i].closest('.Tabindicator');
              const TabindicatorElement = tabRefs?.current?.[i].closest(
                '.TabindicatorElement',
              );
              const positionFromLeft =
                TabindicatorElement.getBoundingClientRect().left -
                Tabsindicator.getBoundingClientRect().left;

              Tabsindicator.scrollBy({
                top: 0,
                left: +positionFromLeft,
                behavior: 'smooth',
              });

              setSelectedIndex(i);
            }}
          >
            <Picto name={picto} size={'big'} />
            {title && (
              <div
                className={classNames(
                  'font-sans text-14',
                  'mb-16 text-center',
                  'w-max',
                  'flex items-center',
                  'justify-center',
                )}
              >
                {title}
              </div>
            )}
          </TitleAndParagraphTab>
        ))}
      </TabIndicator>

      <div className="mt-24">
        <Viewer indexSelected={selectedIndex}>
          <Viewer.Content>
            {data.map((elt, key) => {
              return (
                <Viewer.Element key={key} index={key} className="w-full">
                  <div
                    className={classNames(
                      'flex sm:flex-row justify-start flex-wrap -mx-32 w-full',
                    )}
                  >
                    {elt?.titleAndDescriptionElements.map((item, i) => (
                      <div
                        key={i}
                        className={classNames('w-full sm:w-1/2 md:w-4/12 p-24')}
                      >
                        <div className={classNames('text-16')}>
                          {item.title}
                        </div>
                        <div className={classNames('text-14')}>
                          {item.description}
                        </div>
                      </div>
                    ))}
                  </div>
                </Viewer.Element>
              );
            })}
          </Viewer.Content>
        </Viewer>
      </div>
    </div>
  );
};
